export default {
  editBasicDetails: "editBasicDetails",
  editCompanyDetails: "editCompanyDetails",
  removeEditData: "removeEditData",
};
